import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { CloudUpload } from '@mui/icons-material';
import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import BallotIcon from '@mui/icons-material/Ballot';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DesktopWindowsIcon from '@mui/icons-material/DesktopWindows';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import EmailIcon from '@mui/icons-material/Email';
import ModernChart from './ModernChart';
import ModernDeposits from './ModernDeposits';
import ModernOrders from './ModernOrders';
import Inventory from '../orders/Inventory';
import ManageCategories from './ManageCategories';
import Category from './category/Category';
import Label from './label/Label';
import ManageProducts from './ManageProducts';
import AddProduct from '../items/AddProduct';
import VpnKeySharpIcon from '@mui/icons-material/VpnKeySharp';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import SmtpConfiguration from './email/smtpConfiguration';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import { FormControl, Select, MenuItem, InputLabel } from '@mui/material';
import './dashboard.css';
//APP component
import Groups from './group/Groups';
import ChangePassWord from '../user/ChangePassword';
import Order from '../orders/Order';
import ViewAllGroups from './viewAllGroups';
import ViewMyUser from './viewMyUser';
import ViewMyMachines from './viewMyMachines';
import AddCategoryToMachine from '../machines/AddCategoryToMachine';
import AddProductToMachine from '../machines/AddProductToMachine';
import AddFridgeToMachine from '../machines/AddFridgeToMachine';
import Brand from './brand/brand';
import ViewMyPlano from '../../planogram/ViewMyPlano';
import Promo from './promo/promo';
import CreateGroup from '../items/PromoCode';
import CreateMachine from './createMachine';
import SignUp from '../user/SignUp';
import Logs from '../Logs/Logs';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import MarketingReport from './report/marketingReport/MarketingReport';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';

import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../contexts/userContext';
import { useHistory } from 'react-router';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box, Avatar, Chip } from '@mui/material';
import PrivateRoute from '../../services/PrivateRoute';
import SuperAdminRoute from '../../services/SuperAdminRoute';
import AddBrandToMachine from '../machines/Brands/AddBrandToMachine';
import ReportByUPC from './report/ReportByUPC';
import Report from './report/Report';
import StockLog from './logs/StockLog';
import AlertEmail from './alert/AlertEmail';
import AlertCustom from './alert/AlertCustom';

import ScreenSaver from './screenSaver/ScreenSaver';
import EmailReceipt from './email/EmailReceipt';
import ImportProducts from '../items/ImportProducts';
import CustomAudio from './customAudio/CustomAudio';
import KioskLog from './alert/KioskLog';
import Temperature from './temperature/Temperature';
import Integration from './integration/Integration';
import { useLocation } from 'react-router-dom';
import CashTrans from './cash/CashTrans';
import ViewMember from './member/ViewMember';
import Tickets from './tickets/Tickets';

import DvrIcon from '@mui/icons-material/Dvr';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import CategoryIcon from '@mui/icons-material/Category';
import LabelIcon from '@mui/icons-material/Label';
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ReceiptIcon from '@mui/icons-material/Receipt';
import InventoryIcon from '@mui/icons-material/Inventory';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import AutoGraphOutlinedIcon from '@mui/icons-material/AutoGraphOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import DisplaySettingsOutlinedIcon from '@mui/icons-material/DisplaySettingsOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import MoneyIcon from '@mui/icons-material/Money';
import GroupIcon from '@mui/icons-material/Group';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import EngineeringIcon from '@mui/icons-material/Engineering';
import ComputerIcon from '@mui/icons-material/Computer';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SelectMachinesForMap from './googlemap/SelectMachinesForMap';
import ViewAllMachines from './Admin/ViewAllMachines';
import ViewHFusers from './HFuser/ViewHFuser';
import ManageHFUsers from './HFuser/ManageHFUsers';
import DownloadSales from './Admin/DownloadSales';
import MagexSales from './MagexSales/MagexSales';
import ViewMagexUser from './MagexSales/ViewMagexUser';
import ViewMagexInvoice from './MagexSales/MagexInvoice';
import ViewAlphUsers from './HFuser/ViewAlphUser';
import request from '../../services/Request';
import UserActivityLog from './Admin/UserActivityLog';
import ManageTechUsers from './Admin/ManageTechUsers';
import TransactionSetting from '../orders/TransactionSetting';
import CollapsibleMenuSection from './components/CollapsibleMenuSection';

import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import ThemeToggleButton from '../items/buttons/ThemeToggleButton';

const drawerWidth = 224;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: '100vh',
    maxHeight: '100vh',
    overflow: 'hidden',
    background: theme.palette.background.default,
    fontSize: '0.8rem',
  },
  toolbar: {
    paddingRight: 19.2,
    paddingLeft: 19.2,
    minHeight: '50.6px !important',
    height: 50.6,
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 19.2px',
    height: 51.2,
    minHeight: 51.2,
    background:
      theme.palette.mode === 'dark'
        ? `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`
        : `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
    borderBottom: 'none',
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 3.2px 12.8px rgba(0, 0, 0, 0.3)'
        : '0 3.2px 12.8px rgba(99, 102, 241, 0.2)',
  },
  appBar: {
    zIndex: 1001,
    transition: theme.transitions.create(['width', 'margin', 'box-shadow'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backdropFilter: 'blur(20px)',
    background:
      theme.palette.mode === 'dark'
        ? `linear-gradient(120deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`
        : `linear-gradient(120deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
    boxShadow: 'none',
    borderBottom: `1px solid ${
      theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.2)'
    }`,
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin', 'box-shadow'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 12.8,
    color: 'white',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'rotate(90deg)',
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
    fontWeight: 700,
    fontSize: '1.1rem', // Slightly larger for better readability
    color: '#FFFFFF',
    letterSpacing: '-0.4px',
    textShadow: '0 1.6px 6.4px rgba(0, 0, 0, 0.15)',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    borderRight: 'none',
    background: theme.palette.mode === 'dark' ? theme.palette.background.paper : '#F8F9FA',
    boxShadow: 'none',
    overflowY: 'auto',
    height: '100vh',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    '-ms-overflow-style': 'none',
    'scrollbar-width': 'none',
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(5.6),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(7.2),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    paddingBottom: '80px',
    overflow: 'auto',
    background: theme.palette.mode === 'dark' ? theme.palette.background.default : '#F8F9FA',
    minHeight: '100vh',
  },
  container: {
    paddingTop: theme.spacing(3.2),
    paddingBottom: theme.spacing(3.2),
    maxWidth: '1280px !important',
  },
  paper: {
    padding: theme.spacing(2.4),
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
    borderRadius: 12.8,
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 0.8px 2.4px rgba(0, 0, 0, 0.3)'
        : '0 0.8px 2.4px rgba(0, 0, 0, 0.08)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    border:
      theme.palette.mode === 'dark'
        ? '1px solid rgba(255, 255, 255, 0.05)'
        : '1px solid rgba(0, 0, 0, 0.06)',
    background: theme.palette.mode === 'dark' ? theme.palette.background.paper : '#FFFFFF',
    '&:hover': {
      transform: 'translateY(-2.4px)',
      boxShadow:
        theme.palette.mode === 'dark'
          ? '0 5.6px 17.6px rgba(0, 0, 0, 0.45)'
          : '0 5.6px 17.6px rgba(0, 0, 0, 0.11)',
    },
  },
  fixedHeight: {
    height: 192,
  },
  fixedHeight2: {
    height: 256,
  },
}));

export default function Dashboard() {
  const theme = useTheme();
  const {
    loginStatus,
    setLoginStatus,
    userName,
    setUserName,
    role,
    setRole,
    userEmail,
    setUserEmail,
    referTo,
    setReferTo,
    fullAccess,
    setFullAccess,
  } = useContext(UserContext);
  const user = JSON.parse(localStorage.getItem('user'));
  const features = user?.features;
  const {
    edit_user,
    edit_group,
    view_machine,
    view_plano,
    view_ss,
    view_prod,
    view_cate,
    view_brand,
    view_receipt,
    view_promo,
    view_trans,
    view_report,
    edit_prod,
    view_member,
    ticket,
  } = JSON.parse(localStorage.getItem('limits'));
  // console.log(JSON.parse(localStorage.getItem('limits')));
  // const showSuperAdminAndAdmin = (role === "SuperAdmin" || role === "Admin" || role === "User" && fullAccess) ? true : false;
  const isSuperAdmin = user.role === 'SuperAdmin' ? true : false;
  const isBoxAdmin = user.role === 'BoxAdmin' ? true : false;
  const isMagexAdmin = user.role === 'SuperAdmin' || user.role === 'MagexAdmin';
  const NotBothAdmin =
    user.role == 'SuperAdmin' || user.role === 'BoxAdmin' || user.role === 'MagexAdmin'
      ? true
      : false;

  console.log('user', user);
  const isFullAccess = user?.role === 'Admin' || user?.fullAccess === true;
  const { t } = useTranslation();

  let id = '';
  if (role === 'Admin') id = userEmail;
  else if (role === 'User') id = referTo;

  const history = useHistory();
  const { path } = useRouteMatch();
  const location = useLocation();

  const [showSmtp, setShowSmtp] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [showImport, setImport] = useState(false);
  const [open, setOpen] = React.useState(true);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState([]);
  const [productsDash, setProductsDash] = useState([]);
  const [view, setView] = useState(
    localStorage.getItem('view_prod_option') ? localStorage.getItem('view_prod_option') : 'module'
  );

  // States for collapsible sections - get from localStorage or use defaults
  const [expandedSections, setExpandedSections] = useState(() => {
    const saved = localStorage.getItem('dashboardExpandedSections');
    if (saved) {
      return JSON.parse(saved);
    }
    return {
      userManagement: true,
      machineManagement: true,
      productManagement: true,
      reportsAnalytics: true,
      systemManagement: false,
      accountSettings: false,
      boxAdmin: false,
      magexManagement: false,
      apiAccess: false,
    };
  });

  useEffect(() => {
    localStorage.setItem('view_prod_option', view);
  }, [view]);

  // Save expanded sections to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('dashboardExpandedSections', JSON.stringify(expandedSections));
  }, [expandedSections]);

  const handleSectionToggle = (sectionName) => {
    setExpandedSections((prev) => ({
      ...prev,
      [sectionName]: !prev[sectionName],
    }));
  };

  // Auto-expand relevant section based on current route
  useEffect(() => {
    const path = location.pathname;
    let sectionToExpand = null;

    if (
      path.includes('/viewmyusers') ||
      path.includes('/group') ||
      path.includes('/viewmembers') ||
      path.includes('/viewallgroups')
    ) {
      sectionToExpand = 'userManagement';
    } else if (
      path.includes('/viewmymachines') ||
      path.includes('/planogram') ||
      path.includes('/createmachine') ||
      path.includes('/machinesOnMap')
    ) {
      sectionToExpand = 'machineManagement';
    } else if (
      path.includes('/manage-all-products') ||
      path.includes('/manage-all-categories') ||
      path.includes('/brand') ||
      path.includes('/screenSaver') ||
      path.includes('/customAudio') ||
      path.includes('/emailReceipt') ||
      path.includes('/promo')
    ) {
      sectionToExpand = 'productManagement';
    } else if (
      path.includes('/report') ||
      path.includes('/order') ||
      path.includes('/inventory') ||
      path.includes('/stockLog') ||
      path.includes('/mkReport') ||
      path.includes('/kioskLog') ||
      path.includes('/cashTrans')
    ) {
      sectionToExpand = 'reportsAnalytics';
    } else if (
      path.includes('/alert') ||
      path.includes('/messagePersonalization') ||
      path.includes('/temperature') ||
      path.includes('/manage-smtp') ||
      path.includes('/downloadSales') ||
      path.includes('/userActivityLog') ||
      path.includes('/transseting') ||
      path.includes('/integration')
    ) {
      sectionToExpand = 'systemManagement';
    } else if (path.includes('/changePassword')) {
      sectionToExpand = 'accountSettings';
    } else if (path.includes('/viewmachine')) {
      sectionToExpand = 'boxAdmin';
    } else if (path.includes('/magex')) {
      sectionToExpand = 'magexManagement';
    }

    if (sectionToExpand && !expandedSections[sectionToExpand]) {
      setExpandedSections((prev) => ({
        ...prev,
        [sectionToExpand]: true,
      }));
    }
  }, [location.pathname, expandedSections]);

  const [currLan, setCurrLan] = useState(Cookies.get('i18next') || 'en');
  const lastParam = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('MagexApp.cart');
    localStorage.removeItem('machineName');
    localStorage.removeItem('reRender');
    localStorage.removeItem('limits');
    // localStorage.clear();
    setLoginStatus(false);
    setUserName('');
    setRole('');
    setUserEmail('');
    setReferTo('');
    setFullAccess(false);
    history.push('/signin');
  };

  const dashboardPage = async () => {
    history.push('/dashboard');
  };

  const viewMyUsers = async () => {
    history.push('/dashboard/viewmyusers');
  };

  const manageHFUsers = async () => {
    history.push('/dashboard/userDivisions');
  };

  const viewAllAdmin = async () => {
    history.push('/dashboard/viewallgroups');
  };

  const configureSMTP = async () => {
    history.push('/dashboard/email/manage-smtp');
  };

  const changePassword = async () => {
    history.push('/dashboard/changePassword');
  };

  const viewMyMachines = async () => {
    // if (role === "SuperAdmin")
    //     history.push("/viewallmachines")
    // else
    history.push('/dashboard/viewmymachines');
  };

  const manageAllProducts = async () => {
    history.push('/dashboard/manage-all-products');
  };

  const manageAllCategories = async () => {
    history.push('/dashboard/manage-all-categories');
  };
  const manageAllLabels = async () => {
    history.push('/dashboard/manage-all-labels');
  };
  const manageBrand = async () => {
    history.push('/dashboard/brand');
  };
  const showOrders = async () => {
    history.push('/dashboard/order');
  };
  const showCash = async () => {
    history.push('/dashboard/cashTrans');
  };
  const addNewMachine = async () => {
    history.push('/dashboard/createmachine');
  };
  const group = async () => {
    history.push('/dashboard/group');
  };
  const promo = async () => {
    history.push('/dashboard/promo');
  };

  const screenSaver = async () => {
    history.push('/dashboard/screenSaver');
  };

  const customAudio = async () => {
    history.push('/dashboard/customAudio');
  };

  const emailReceipt = async () => {
    history.push('/dashboard/emailReceipt');
  };

  const viewPlano = async () => {
    history.push('/dashboard/planogram');
  };

  const viewReport = async () => {
    history.push('/dashboard/report');
  };

  const viewReportByUPC = async () => {
    history.push('/dashboard/reportByUPC');
  };

  const inventory = async () => {
    history.push('/dashboard/inventory');
  };

  const stockLog = async () => {
    history.push('/dashboard/stockLog');
  };

  const mkReport = async () => {
    history.push('/dashboard/mkReport');
  };

  const alert = async () => {
    history.push('/dashboard/alert');
  };

  const kioskLog = async () => {
    history.push('/dashboard/kioskLog');
  };

  const temperature = async () => {
    history.push('/dashboard/temperature');
  };

  const messagePersonalization = async () => {
    history.push('/dashboard/messagePersonalization');
  };

  const integration = () => {
    history.push('/dashboard/integration');
  };

  const downloadLog = async () => {
    history.push('/dashboard/log');
  };

  const downloadSales = async () => {
    history.push('/dashboard/downloadSales');
  };

  const machinesOnMap = async () => {
    history.push('/dashboard/machinesOnMap');
  };

  const viewMachine = async () => {
    history.push('/dashboard/viewmachine');
  };

  const userActivityLog = async () => {
    history.push('/dashboard/userActivityLog');
  };

  const transseting = async () => {
    history.push('/dashboard/transseting');
  };

  const manageTechUsers = async () => {
    history.push('/dashboard/manageTechUsers');
  };

  const viewMyMembers = async () => {
    history.push('/dashboard/viewmembers');
  };

  const viewTickets = async () => {
    history.push('/dashboard/tickets');
  };

  useEffect(() => {
    const logAction = async (actionName) => {
      const logData = {
        user: user?._id,
        actionType: 'View',
        details: `${actionName}`,
        referTo: user?.role === 'Admin' ? user?.email : user?.referTo,
      };

      try {
        // await request('/api/logs', logData);
        // Using custom request style
        request({
          method: 'post',
          url: '/userLogs/createUserPortalLog',
          data: logData,
        })
          .then((res) => {
            console.log('Log created or updated:', res.data);
          })
          .catch((error) => {
            console.error('Error logging action:', error);
          });
      } catch (error) {
        console.error('Error logging action:', error);
      }
    };

    const path = window.location.pathname;
    let actionName = '';

    if (path === '/dashboard') {
      actionName = 'Home Page';
    } else if (path === '/dashboard/manage-all-categories') {
      actionName = 'Categories';
    } else if (path === '/dashboard/manage-all-products') {
      actionName = 'Products';
    } else if (path.indexOf('/dashboard/viewmyusers') === 0) {
      actionName = 'Users';
    } else if (path.indexOf('/dashboard/group') === 0) {
      actionName = 'Groups';
    } else if (path.indexOf('/dashboard/viewmymachines') === 0) {
      actionName = 'Machines';
    } else if (path.indexOf('/dashboard/viewallgroups') === 0) {
      actionName = 'Groups';
    } else if (path.indexOf('/dashboard/planogram') === 0) {
      actionName = 'Planograms';
    } else if (path.indexOf('/dashboard/brand') === 0) {
      actionName = 'Brands';
    } else if (path.indexOf('/dashboard/order') === 0) {
      actionName = 'Transactions';
    } else if (path.indexOf('/dashboard/promo') === 0) {
      actionName = 'Promos';
    } else if (path.indexOf('/dashboard/screenSaver') === 0) {
      actionName = 'Screen Saver';
    } else if (path.indexOf('/dashboard/customAudio') === 0) {
      actionName = 'Custom Audio';
    } else if (path.indexOf('/dashboard/log') === 0) {
      actionName = 'Stocking Log';
    } else if (path.indexOf('/dashboard/report') === 0) {
      actionName = 'Reports';
    } else if (path.indexOf('/dashboard/emailReceipt') === 0) {
      actionName = 'Email Receipt';
    } else if (path.indexOf('/dashboard/inventory') === 0) {
      actionName = 'Inventory';
    } else if (path.indexOf('/dashboard/stockLog') === 0) {
      actionName = 'Stocking Log';
    } else if (path.indexOf('/dashboard/mkReport') === 0) {
      actionName = 'Marketing Report';
    } else if (path.indexOf('/dashboard/alert') === 0) {
      actionName = 'Alerts';
    } else if (path.indexOf('/dashboard/kioskLog') === 0) {
      actionName = 'Kiosk Log';
    } else if (path.indexOf('/dashboard/cashTrans') === 0) {
      actionName = 'Cash Transactions';
    }

    if (actionName && user?.features?.portal_log) {
      console.log('Logging action:', actionName);
      logAction(actionName);
    }
  }, []);

  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const fixedHeightPaper2 = clsx(classes.paper, classes.fixedHeight2);

  const mainDashboardComponent = () => {
    return (
      <Container maxWidth="xl" className={classes.container}>
        <Grid container spacing={2.4}>
          {/* Account Info & Storage - Moved to top left */}
          <Grid item xs={12} md={4}>
            <Paper
              className={classes.paper}
              sx={{
                height: 336,
              }}
            >
              <ModernDeposits user={user} name={userName} role={role} fullAccess={fullAccess} />
            </Paper>
          </Grid>
          {/* Chart Section - Moved to top right with more space */}
          <Grid item xs={12} md={8}>
            <Paper
              className={classes.paper}
              sx={{
                height: 336,
              }}
            >
              <ModernChart id={id} view_trans={view_trans} />
            </Paper>
          </Grid>
          {/* Recent Transactions Table - Full width at bottom */}
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <ModernOrders
                loading={loading}
                setLoading={setLoading}
                order={order}
                setOrder={setOrder}
                id={id}
                view_trans={view_trans}
              />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    );
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
            size="large"
          >
            <MenuIcon />
          </IconButton>
          {window.location.pathname.includes('/dashboard/manage-all-products') &&
            edit_prod &&
            (view !== 'bundle' ? (
              <Button
                onClick={() => setShowAdd(true)}
                size="medium"
                startIcon={<AddCircleIcon sx={{ fontSize: '1.3rem' }} />}
                sx={{
                  color: 'white',
                  fontSize: '0.7rem',
                  padding: '5px 14px',
                  marginRight: '10px',
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.25)',
                  },
                }}
              >
                Add Product
              </Button>
            ) : (
              <Button
                onClick={() => setShowAdd(true)}
                size="medium"
                startIcon={<AddCircleIcon sx={{ fontSize: '1.3rem' }} />}
                sx={{
                  color: 'white',
                  fontSize: '0.7rem',
                  padding: '5px 14px',
                  marginRight: '10px',
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.25)',
                  },
                }}
              >
                Add Bundle
              </Button>
            ))}
          {user?.theme === '0' &&
            window.location.pathname.includes('/dashboard/manage-all-products') &&
            edit_prod && (
              <Button
                onClick={() => setImport(true)}
                size="medium"
                startIcon={<CloudUpload sx={{ fontSize: '1.3rem' }} />}
                sx={{
                  color: 'white',
                  fontSize: '0.8rem', // Slightly larger
                  padding: '5px 14px', // Slightly larger padding
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.25)',
                  },
                }}
              >
                Import Products
              </Button>
            )}

          <AddProduct
            show={showAdd}
            onHide={() => setShowAdd(false)}
            productsDash={productsDash}
            isBundle={view === 'bundle'}
          />
          <ImportProducts show={showImport} onHide={() => setImport(false)} />
          <Typography component="h1" variant="h6" noWrap className={classes.title}>
            {window.location.pathname === '/dashboard' && 'Home Page'}
            {window.location.pathname === '/dashboard/manage-all-categories' && 'Categories'}
            {window.location.pathname === '/dashboard/manage-all-products' && 'Manage All Products'}
            {window.location.pathname.indexOf('/dashboard/viewmyusers') === 0 && 'Users'}
            {window.location.pathname.indexOf('/dashboard/userDivisions') === 0 &&
              'Users & Divisions'}
            {window.location.pathname.indexOf('/dashboard/viewmembers') === 0 && 'Members'}
            {window.location.pathname.indexOf('/dashboard/group') === 0 && 'Groups'}
            {window.location.pathname.indexOf('/dashboard/viewmymachines') === 0 && 'Machines'}
            {window.location.pathname.indexOf('/dashboard/viewallgroups') === 0 && 'Groups'}
            {window.location.pathname.indexOf('/dashboard/planogram') === 0 && 'Planograms'}
            {window.location.pathname.indexOf('/dashboard/brand') === 0 && 'Brands'}
            {window.location.pathname.indexOf('/dashboard/order') === 0 && 'Transactions'}
            {window.location.pathname.indexOf('/dashboard/promo') === 0 && 'Promos'}
            {window.location.pathname.indexOf('/dashboard/screenSaver') === 0 && 'Screen Saver'}
            {window.location.pathname.indexOf('/dashboard/customAudio') === 0 && 'Custom Audio'}
            {window.location.pathname.indexOf('/dashboard/log') === 0 && 'Stocking Log'}
            {window.location.pathname.indexOf('/dashboard/report') === 0 && 'Reports'}
            {window.location.pathname.indexOf('/dashboard/emailReceipt') === 0 && 'Email receipt'}
            {window.location.pathname.indexOf('/dashboard/inventory') === 0 && 'Inventory'}
            {window.location.pathname.indexOf('/dashboard/stockLog') === 0 && 'Stocking Log'}
            {window.location.pathname.indexOf('/dashboard/temperature') === 0 && 'Temperature'}
            {window.location.pathname.indexOf('/dashboard/integration') === 0 && 'API Access'}
            {window.location.pathname.indexOf('/dashboard/mkReport') === 0 && 'Marketing Report'}
            {window.location.pathname.indexOf('/dashboard/alert') === 0 && 'Alerts'}
            {window.location.pathname.indexOf('/dashboard/kioskLog') === 0 && 'Kiosk Log'}
            {window.location.pathname.indexOf('/dashboard/cashTrans') === 0 && 'Cash Transactions'}
            {window.location.pathname.indexOf('/dashboard/messagePersonalization') === 0 &&
              'Message Personalization'}
            {window.location.pathname.indexOf('/dashboard/magexsales') === 0 && 'Sales Report'}
            {window.location.pathname.indexOf('/dashboard/viewAlphUsers') === 0 &&
              'View Alphasite Users'}
            {window.location.pathname.indexOf('/dashboard/magexusers') === 0 && 'Operators'}
            {window.location.pathname.indexOf('/dashboard/magexinvoice') === 0 && 'Setup'}
            {window.location.pathname.indexOf('/dashboard/userActivityLog') === 0 &&
              'User Activity Log'}
            {window.location.pathname.indexOf('/dashboard/manageTechUsers') === 0 &&
              'Tech & Ticket Users'}
            {window.location.pathname.indexOf('/dashboard/addProductsToFridge') === 0 &&
              'Add Products To Fridge'}
            {window.location.pathname.indexOf('/dashboard/tickets') === 0 && 'Tickets'}
          </Typography>
          {/* <IconButton color="inherit">
            <Badge badgeContent={0} color="secondary">
              <NotificationsIcon />
            </Badge>
          </IconButton> */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {/* <Box sx={{ '& .MuiIconButton-root': { color: 'white' } }}>
              <ThemeToggleButton />
            </Box> */}
            <Tooltip title="Exit">
              <IconButton
                aria-label="Exit"
                onClick={logout}
                size="large"
                sx={{
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  },
                }}
              >
                <ExitToAppIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        style={{ zIndex: 1000 }}
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, flex: 1 }}>
            <Avatar
              sx={{
                width: 28.8,
                height: 28.8,
                bgcolor: 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                fontWeight: 700,
                fontSize: '0.72rem',
                boxShadow: '0 1.6px 6.4px rgba(0, 0, 0, 0.2)',
                border: '1.6px solid rgba(255, 255, 255, 0.3)',
              }}
            >
              {user.firstname?.charAt(0)}
              {user.lastname?.charAt(0)}
            </Avatar>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 700,
                  fontSize: '0.68rem',
                  lineHeight: 1.2,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  color: 'white',
                }}
              >
                {`${user.firstname} ${user.lastname}`}
              </Typography>
              <Chip
                label={user.role}
                size="small"
                sx={{
                  height: 14.4,
                  fontSize: '0.52rem',
                  fontWeight: 600,
                  mt: 0.24,
                  bgcolor: 'rgba(255, 255, 255, 0.2)',
                  color: 'white',
                  border: '0.8px solid rgba(255, 255, 255, 0.3)',
                }}
              />
            </Box>
          </Box>
          <IconButton
            onClick={handleDrawerClose}
            size="small"
            sx={{
              color: 'white',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'scale(1.1)',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List
          sx={{
            '& .MuiListItem-root': {
              borderRadius: 1.6,
              margin: '3.2px 6.4px',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              fontSize: '0.8rem', // Scaled font
              '&:hover': {
                backgroundColor: theme.alpha(theme.palette.primary.main, 0.08),
                transform: 'translateX(3.2px)',
                boxShadow: `0 1.6px 6.4px ${theme.alpha(theme.palette.primary.main, 0.1)}`,
                '& .MuiListItemIcon-root': {
                  transform: 'scale(1.1)',
                  color: theme.palette.primary.main,
                },
              },
              '&.dashboardtag': {
                background:
                  theme.palette.mode === 'dark'
                    ? `linear-gradient(135deg, ${theme.alpha(
                        theme.palette.primary.main,
                        0.25
                      )} 0%, ${theme.alpha(theme.palette.primary.main, 0.15)} 100%)`
                    : `linear-gradient(135deg, ${theme.alpha(
                        theme.palette.primary.main,
                        0.2
                      )} 0%, ${theme.alpha(theme.palette.primary.main, 0.1)} 100%)`,
                borderLeft: `3.2px solid ${theme.palette.primary.main}`,
                boxShadow: `0 3.2px 9.6px ${theme.alpha(theme.palette.primary.main, 0.3)}`,
                '& .MuiListItemIcon-root': {
                  color: theme.palette.primary.main,
                  transform: 'scale(1.1)',
                },
                '& .MuiListItemText-primary': {
                  color: theme.palette.primary.main,
                  fontWeight: 700,
                },
              },
            },
            '& .MuiListItemIcon-root': {
              minWidth: 28.8,
              transition: 'all 0.3s ease',
            },
          }}
        >
          <div>
            {/* Home Page - Always visible at top */}
            <ListItem
              button
              onClick={dashboardPage}
              className={lastParam === 'dashboard' ? 'dashboardtag' : ''}
              style={{ paddingLeft: 6.4, paddingRight: 6.4, minHeight: 32 }}
            >
              <ListItemIcon style={{ minWidth: 25.6, marginRight: 6.4 }}>
                <DashboardIcon sx={{ fontSize: '1.2rem' }} />
              </ListItemIcon>
              <ListItemText
                primary="Home Page"
                primaryTypographyProps={{
                  style: { fontSize: '0.95rem', fontWeight: 500, lineHeight: 1.2 },
                }}
              />
            </ListItem>
            <Divider />

            {/* SuperAdmin only sees specific functions */}
            {isSuperAdmin ? (
              <>
                {/* All Groups - Direct menu item for SuperAdmin */}
                <ListItem
                  button
                  onClick={viewAllAdmin}
                  className={lastParam === 'viewallgroups' ? 'dashboardtag' : ''}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <PeopleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="All Groups"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                {/* Tech & Ticket Users */}
                <ListItem
                  button
                  onClick={manageTechUsers}
                  className={lastParam === 'manageTechUsers' ? 'dashboardtag' : ''}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <EngineeringIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Tech & Ticket Users"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                {/* SMTP Configuration */}
                <ListItem
                  button
                  onClick={configureSMTP}
                  className={lastParam === 'manage-smtp' ? 'dashboardtag' : ''}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <EmailIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="SMTP Configuration"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                {/* Add New Machines */}
                <ListItem
                  button
                  onClick={addNewMachine}
                  className={lastParam === 'createmachine' ? 'dashboardtag' : ''}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <AddCircleRoundedIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Add New Machines"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                {/* Machines on Map */}
                <ListItem
                  button
                  onClick={machinesOnMap}
                  className={lastParam === 'machinesOnMap' ? 'dashboardtag' : ''}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <PeopleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Machines on Map"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                {/* Download Sales By Machine */}
                <ListItem
                  button
                  onClick={downloadSales}
                  className={lastParam === 'downloadSales' ? 'dashboardtag' : ''}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <PeopleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Download Sales By Machine"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                {/* User Activity Log */}
                <ListItem
                  button
                  onClick={userActivityLog}
                  className={lastParam === 'userActivityLog' ? 'dashboardtag' : ''}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <PeopleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="User Activity Log"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                {/* Transaction Setting */}
                <ListItem
                  button
                  onClick={transseting}
                  className={lastParam === 'transseting' ? 'dashboardtag' : ''}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <PeopleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Transaction Setting"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                {/* View Machines for SuperAdmin */}
                <ListItem
                  button
                  onClick={viewMachine}
                  className={lastParam === 'viewmachine' ? 'dashboardtag' : ''}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <PeopleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="View Machines"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                {/* Kiosk Log for SuperAdmin */}
                <ListItem
                  button
                  onClick={kioskLog}
                  className={lastParam === 'kioskLog' ? 'dashboardtag' : ''}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <AnalyticsOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Kiosk Log"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                {/* Magex Management Functions for SuperAdmin */}
                <ListItem
                  button
                  className={lastParam === 'magexusers' ? 'dashboardtag' : ''}
                  onClick={() => {
                    history.push('/dashboard/magexusers');
                  }}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <AnalyticsOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Operators"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                <ListItem
                  button
                  className={lastParam === 'magexsales' ? 'dashboardtag' : ''}
                  onClick={() => {
                    history.push('/dashboard/magexsales');
                  }}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <AnalyticsOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Sales Report"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                <ListItem
                  button
                  className={lastParam === 'magexinvoice' ? 'dashboardtag' : ''}
                  onClick={() => {
                    history.push('/dashboard/magexinvoice');
                  }}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <AnalyticsOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Setup"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                <Divider />

                {/* Password & Email for SuperAdmin */}
                <ListItem
                  button
                  onClick={changePassword}
                  className={lastParam === 'changePassword' ? 'dashboardtag' : ''}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <VpnKeySharpIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Password & Email"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>
              </>
            ) : (
              /* User Management Section for non-SuperAdmin */
              !NotBothAdmin && (
                <CollapsibleMenuSection
                  title="User Management"
                  icon={<GroupIcon />}
                  expanded={expandedSections.userManagement}
                  onToggle={() => handleSectionToggle('userManagement')}
                >
                  {edit_user && (
                    <ListItem
                      button
                      onClick={viewMyUsers}
                      className={lastParam === 'viewmyusers' ? 'dashboardtag' : ''}
                    >
                      <ListItemIcon>
                        <PeopleIcon />
                      </ListItemIcon>
                      <ListItemText primary="Users" />
                    </ListItem>
                  )}
                  {edit_group && (
                    <ListItem
                      button
                      onClick={group}
                      className={lastParam === 'group' ? 'dashboardtag' : ''}
                    >
                      <ListItemIcon>
                        <PeopleOutlineIcon />
                      </ListItemIcon>
                      <ListItemText primary="Groups" />
                    </ListItem>
                  )}
                  {edit_user &&
                    (id === 'tianlangwu001@gmail.com' || id === 'cs.ds@avantorsciences.com') && (
                      <ListItem
                        button
                        onClick={manageHFUsers}
                        className={lastParam === 'userDivisions' ? 'dashboardtag' : ''}
                      >
                        <ListItemIcon>
                          <GroupIcon />
                        </ListItemIcon>
                        <ListItemText primary="Users & Divisions" />
                      </ListItem>
                    )}
                  {user?.features?.mobile && view_member && (
                    <ListItem
                      button
                      onClick={viewMyMembers}
                      className={lastParam === 'viewmembers' ? 'dashboardtag' : ''}
                    >
                      <ListItemIcon>
                        <PeopleIcon />
                      </ListItemIcon>
                      <ListItemText primary="Members" />
                    </ListItem>
                  )}
                </CollapsibleMenuSection>
              )
            )}

            {/* Machine Management Section */}
            {!NotBothAdmin && !isSuperAdmin && (
              <CollapsibleMenuSection
                title="Machine Management"
                icon={<ComputerIcon />}
                expanded={expandedSections.machineManagement}
                onToggle={() => handleSectionToggle('machineManagement')}
              >
                {view_machine && (
                  <ListItem
                    button
                    onClick={viewMyMachines}
                    className={lastParam === 'viewmymachines' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <DesktopWindowsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Machines" />
                  </ListItem>
                )}

                {view_plano && (
                  <ListItem
                    button
                    onClick={viewPlano}
                    className={lastParam === 'planogram' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <DvrIcon />
                    </ListItemIcon>
                    <ListItemText primary="Planograms" />
                  </ListItem>
                )}
              </CollapsibleMenuSection>
            )}

            {/* Product Management Section */}
            {!NotBothAdmin && !isSuperAdmin && (
              <CollapsibleMenuSection
                title="Product Management"
                icon={<ShoppingCartIcon />}
                expanded={expandedSections.productManagement}
                onToggle={() => handleSectionToggle('productManagement')}
              >
                {view_prod && (
                  <ListItem
                    button
                    onClick={manageAllProducts}
                    className={lastParam === 'manage-all-products' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <BallotIcon />
                    </ListItemIcon>
                    <ListItemText primary="Products" />
                  </ListItem>
                )}

                {view_cate && (
                  <ListItem
                    button
                    onClick={manageAllCategories}
                    className={lastParam === 'manage-all-categories' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <CategoryIcon />
                    </ListItemIcon>
                    <ListItemText primary="Categories" />
                  </ListItem>
                )}

                {view_cate && !features?.extra && (
                  <ListItem
                    button
                    onClick={manageAllLabels}
                    className={lastParam === 'manage-all-labels' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <LabelIcon />
                    </ListItemIcon>
                    <ListItemText primary="Labels" />
                  </ListItem>
                )}

                {view_brand && (
                  <ListItem
                    button
                    onClick={manageBrand}
                    className={lastParam === 'brand' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <BrandingWatermarkIcon />
                    </ListItemIcon>
                    <ListItemText primary="Brands" />
                  </ListItem>
                )}

                {view_ss && (
                  <ListItem
                    button
                    onClick={screenSaver}
                    className={lastParam === 'screenSaver' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <OndemandVideoIcon />
                    </ListItemIcon>
                    <ListItemText primary="Screen Saver" />
                  </ListItem>
                )}

                {view_ss && !features.disableAudio && (
                  <ListItem
                    button
                    onClick={customAudio}
                    className={lastParam === 'customAudio' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <LibraryMusicIcon />
                    </ListItemIcon>
                    <ListItemText primary="Custom Audio" />
                  </ListItem>
                )}

                {view_receipt && (
                  <ListItem
                    button
                    onClick={emailReceipt}
                    className={lastParam === 'emailReceipt' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <MailOutlineIcon />
                    </ListItemIcon>
                    <ListItemText primary="Email Receipt" />
                  </ListItem>
                )}

                {view_promo && !features?.disablePromo && (
                  <ListItem
                    button
                    onClick={promo}
                    className={lastParam === 'promo' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <MoneyOffIcon />
                    </ListItemIcon>
                    <ListItemText primary="Promotions" />
                  </ListItem>
                )}
              </CollapsibleMenuSection>
            )}

            {/* Reports & Analytics Section */}
            {!NotBothAdmin && !isSuperAdmin && (
              <CollapsibleMenuSection
                title="Reports & Analytics"
                icon={<BarChartIcon />}
                expanded={expandedSections.reportsAnalytics}
                onToggle={() => handleSectionToggle('reportsAnalytics')}
              >
                {view_report && (
                  <ListItem
                    button
                    onClick={viewReport}
                    className={lastParam === 'report' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <BarChartIcon />
                    </ListItemIcon>
                    <ListItemText primary="Reports" />
                  </ListItem>
                )}

                {view_report && (
                  <ListItem
                    button
                    onClick={viewReportByUPC}
                    className={lastParam === 'reportByUPC' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <AssessmentIcon />
                    </ListItemIcon>
                    <ListItemText primary="Reports(UPC/SKU)" />
                  </ListItem>
                )}

                {view_trans && (
                  <ListItem
                    button
                    onClick={showOrders}
                    className={lastParam === 'order' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <ReceiptIcon />
                    </ListItemIcon>
                    <ListItemText primary="Transactions" />
                  </ListItem>
                )}

                {features?.extra && view_trans && (
                  <ListItem
                    button
                    onClick={showCash}
                    className={lastParam === 'cash' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <MoneyIcon />
                    </ListItemIcon>
                    <ListItemText primary="Cash Transactions" />
                  </ListItem>
                )}

                {view_report && (
                  <ListItem
                    button
                    onClick={inventory}
                    className={lastParam === 'inventory' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <InventoryIcon />
                    </ListItemIcon>
                    <ListItemText primary="Inventory" />
                  </ListItem>
                )}

                {view_report && (
                  <ListItem
                    button
                    onClick={stockLog}
                    className={lastParam === 'stockLog' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <Inventory2OutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Stocking Log" />
                  </ListItem>
                )}

                {!features?.disableMR && view_report && (
                  <ListItem
                    button
                    onClick={mkReport}
                    className={lastParam === 'mkReport' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <AutoGraphOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Marketing Reports" />
                  </ListItem>
                )}

                {features?.extra && view_report && (
                  <ListItem
                    button
                    onClick={kioskLog}
                    className={lastParam === 'kioskLog' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <AnalyticsOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Kiosk Log" />
                  </ListItem>
                )}
              </CollapsibleMenuSection>
            )}

            {/* System Management Section */}
            {!NotBothAdmin && !isSuperAdmin && (!features?.disableAlert || features?.temperature) && (
              <CollapsibleMenuSection
                title="System Management"
                icon={<SettingsIcon />}
                expanded={expandedSections.systemManagement}
                onToggle={() => handleSectionToggle('systemManagement')}
              >
                {!features?.disableAlert && view_report && (
                  <ListItem
                    button
                    onClick={alert}
                    className={lastParam === 'alert' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <WarningAmberOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Alert" />
                  </ListItem>
                )}

                {!features?.disableAlert && view_report && (
                  <ListItem
                    button
                    onClick={messagePersonalization}
                    className={lastParam === 'messagePersonalization' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <DisplaySettingsOutlinedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Msg Personalization" />
                  </ListItem>
                )}

                {features?.temperature && view_report && (
                  <ListItem
                    button
                    onClick={temperature}
                    className={lastParam === 'temperature' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <DeviceThermostatIcon />
                    </ListItemIcon>
                    <ListItemText primary="Temperature" />
                  </ListItem>
                )}

                {features?.enableAPI && isFullAccess && (
                  <ListItem
                    button
                    onClick={integration}
                    className={lastParam === 'integration' ? 'dashboardtag' : ''}
                  >
                    <ListItemIcon>
                      <VpnKeySharpIcon />
                    </ListItemIcon>
                    <ListItemText primary="API Access" />
                  </ListItem>
                )}
              </CollapsibleMenuSection>
            )}

            {/* Tickets - visible for fullAccess, ticket permission, or Admin */}
            {!isSuperAdmin && (isFullAccess || ticket || user.role === 'Admin') && (
              <ListItem
                button
                onClick={viewTickets}
                className={lastParam === 'tickets' ? 'dashboardtag' : ''}
                style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
              >
                <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                  <ConfirmationNumberIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Tickets"
                  primaryTypographyProps={{
                    style: { fontSize: '0.875rem', fontWeight: 500, lineHeight: 1.2 },
                  }}
                />
              </ListItem>
            )}

            {/* Password & Email for non-SuperAdmin and non-BoxAdmin */}
            {!isSuperAdmin && user.role !== 'BoxAdmin' && (
              <ListItem
                button
                onClick={changePassword}
                className={lastParam === 'changePassword' ? 'dashboardtag' : ''}
                style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
              >
                <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                  <VpnKeySharpIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Password & Email"
                  primaryTypographyProps={{
                    style: { fontSize: '0.875rem', fontWeight: 500, lineHeight: 1.2 },
                  }}
                />
              </ListItem>
            )}

            {/* BoxAdmin specific menu - only shows 3 functions */}
            {user.role === 'BoxAdmin' && (
              <>
                {/* Password & Email for BoxAdmin */}
                <ListItem
                  button
                  onClick={changePassword}
                  className={lastParam === 'changePassword' ? 'dashboardtag' : ''}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <VpnKeySharpIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Password & Email"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                {/* View Machines for BoxAdmin */}
                <ListItem
                  button
                  onClick={viewMachine}
                  className={lastParam === 'viewmachine' ? 'dashboardtag' : ''}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <PeopleIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="View Machines"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>

                {/* Kiosk Log for BoxAdmin */}
                <ListItem
                  button
                  onClick={kioskLog}
                  className={lastParam === 'kioskLog' ? 'dashboardtag' : ''}
                  style={{ paddingLeft: 8, paddingRight: 8, minHeight: 40 }}
                >
                  <ListItemIcon style={{ minWidth: 32, marginRight: 8 }}>
                    <AnalyticsOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Kiosk Log"
                    primaryTypographyProps={{
                      style: { fontSize: '1rem', fontWeight: 500, lineHeight: 1.2 },
                    }}
                  />
                </ListItem>
              </>
            )}

            {/* Magex Management for non-SuperAdmin MagexAdmin */}
            {(id === '1234@gmail.com' || isMagexAdmin) && !isSuperAdmin && (
              <CollapsibleMenuSection
                title="Magex Management"
                icon={<SettingsIcon />}
                expanded={expandedSections.magexManagement}
                onToggle={() => handleSectionToggle('magexManagement')}
              >
                <ListItem
                  button
                  className={lastParam === 'magexusers' ? 'dashboardtag' : ''}
                  onClick={() => {
                    history.push('/dashboard/magexusers');
                  }}
                >
                  <ListItemIcon>
                    <AnalyticsOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Operators" />
                </ListItem>

                <ListItem
                  button
                  className={lastParam === 'magexsales' ? 'dashboardtag' : ''}
                  onClick={() => {
                    history.push('/dashboard/magexsales');
                  }}
                >
                  <ListItemIcon>
                    <AnalyticsOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Sales Report" />
                </ListItem>

                <ListItem
                  button
                  className={lastParam === 'magexinvoice' ? 'dashboardtag' : ''}
                  onClick={() => {
                    history.push('/dashboard/magexinvoice');
                  }}
                >
                  <ListItemIcon>
                    <AnalyticsOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText primary="Setup" />
                </ListItem>
              </CollapsibleMenuSection>
            )}

            {/* Logout - Always at bottom */}
            <Divider />
            <ListItem button onClick={logout}>
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText primary="Log Out" />
            </ListItem>
          </div>
        </List>
      </Drawer>
      <div id="swal2-container" className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Switch>
          <Route exact path={`${path}/`}>
            {mainDashboardComponent()}
          </Route>
          <PrivateRoute exact path={`${path}/group`} component={Groups}></PrivateRoute>
          <PrivateRoute exact path={`${path}/group/:id/:group`} component={Groups}></PrivateRoute>
          <PrivateRoute
            exact
            path={`${path}/changePassword`}
            component={ChangePassWord}
          ></PrivateRoute>
          <PrivateRoute exact path={`${path}/order`} component={Order}></PrivateRoute>
          <PrivateRoute exact path={`${path}/order/:id/:group`} component={Order}></PrivateRoute>
          <PrivateRoute exact path={`${path}/memberorder/:id`} component={Order}></PrivateRoute>
          <PrivateRoute
            exact
            path={`${path}/viewallgroups`}
            component={ViewAllGroups}
          ></PrivateRoute>
          <PrivateRoute exact path={`${path}/viewmyusers`} component={ViewMyUser}></PrivateRoute>
          <PrivateRoute exact path={`${path}/viewHFusers`} component={ViewHFusers}></PrivateRoute>
          <PrivateRoute
            exact
            path={`${path}/userDivisions`}
            component={ManageHFUsers}
          ></PrivateRoute>

          <PrivateRoute
            exact
            path={`${path}/viewAlphUsers`}
            component={ViewAlphUsers}
          ></PrivateRoute>
          <PrivateRoute exact path={`${path}/viewmembers`} component={ViewMember}></PrivateRoute>
          <PrivateRoute
            exact
            path={`${path}/viewmyusers/:id/:group/:_id`}
            component={ViewMyUser}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path={`${path}/viewmymachines`}
            component={ViewMyMachines}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path={`${path}/viewmymachines/:id/:group`}
            component={ViewMyMachines}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path={`${path}/addCategories/:id`}
            component={AddCategoryToMachine}
          ></PrivateRoute>
          {/* <PrivateRoute exact path={`${path}/addCategories`} component={AddCategoryToMachine}></PrivateRoute > */}
          <PrivateRoute
            exact
            path={`${path}/addBrands/:id`}
            component={AddBrandToMachine}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path={`${path}/addProducts/:id`}
            component={AddProductToMachine}
          ></PrivateRoute>
          <PrivateRoute
            exact
            path={`${path}/addProductsToFridge/:id`}
            component={AddFridgeToMachine}
          ></PrivateRoute>
          <PrivateRoute exact path={`${path}/brand`} component={Brand}></PrivateRoute>
          <PrivateRoute exact path={`${path}/brand/:id/:group`} component={Brand}></PrivateRoute>
          <PrivateRoute exact path={`${path}/emailReceipt`} component={EmailReceipt}></PrivateRoute>
          <PrivateRoute
            exact
            path={`${path}/emailReceipt/:id/:group`}
            component={EmailReceipt}
          ></PrivateRoute>
          <Route exact path={`${path}/planogram`} component={ViewMyPlano} />
          <Route exact path={`${path}/planogram/:id/:group`} component={ViewMyPlano} />
          <PrivateRoute exact path={`${path}/promo`} component={Promo}></PrivateRoute>
          <PrivateRoute exact path={`${path}/promo/:id/:group`} component={Promo}></PrivateRoute>
          <PrivateRoute exact path={`${path}/createGroup`} component={CreateGroup}></PrivateRoute>
          <SuperAdminRoute
            exact
            path={`${path}/createmachine`}
            component={CreateMachine}
          ></SuperAdminRoute>
          <PrivateRoute exact path={`${path}/signUp`} component={SignUp} />
          <PrivateRoute exact path={`${path}/signUp/:id/:_id`} component={SignUp} />
          <PrivateRoute exact path={`${path}/log`} component={Logs} />
          <PrivateRoute exact path={`${path}/log/:id`} component={Logs} />
          <PrivateRoute exact path={`${path}/screenSaver`} component={ScreenSaver}></PrivateRoute>
          <PrivateRoute
            exact
            path={`${path}/screenSaver/:id/:group`}
            component={ScreenSaver}
          ></PrivateRoute>
          <PrivateRoute exact path={`${path}/customAudio`} component={CustomAudio}></PrivateRoute>
          <PrivateRoute
            exact
            path={`${path}/customAudio/:id/:group`}
            component={CustomAudio}
          ></PrivateRoute>
          <Route path={`${path}/manage-all-products`}>
            <ManageProducts setProductsDash={setProductsDash} view={view} setView={setView} />
          </Route>
          <Route exact path={`${path}/manage-all-categories`} component={Category}></Route>
          <Route exact path={`${path}/manage-all-categories/:id/:group`} component={Category} />
          <Route exact path={`${path}/manage-all-labels`} component={Label}></Route>
          <Route exact path={`${path}/manage-all-labels/:id/:group`} component={Label} />
          <Route exact path={`${path}/report`} component={Report}></Route>
          <Route exact path={`${path}/report/:id/:group`} component={Report} />
          <Route exact path={`${path}/mkReport`} component={MarketingReport}></Route>
          <Route exact path={`${path}/mkReport/:id/:group`} component={MarketingReport} />
          <Route exact path={`${path}/reportByUPC`} component={ReportByUPC}></Route>
          <Route exact path={`${path}/reportByUPC/:id/:group`} component={ReportByUPC} />
          <Route exact path={`${path}/inventory`} component={Inventory}></Route>
          <Route exact path={`${path}/inventory/:id/:group`} component={Inventory} />
          <Route exact path={`${path}/cashTrans`} component={CashTrans}></Route>
          <Route exact path={`${path}/cashTrans/:id/:group`} component={CashTrans} />
          <Route exact path={`${path}/stockLog`} component={StockLog}></Route>
          <Route exact path={`${path}/stockLog/:id/:group`} component={StockLog} />
          <Route exact path={`${path}/temperature`} component={Temperature}></Route>
          <Route exact path={`${path}/temperature/:id/:group`} component={Temperature} />
          {isFullAccess && features?.enableAPI ? (
            <Route exact path={`${path}/integration`} component={Integration} />
          ) : (
            <Route exact path={`${path}/integration`} render={() => <Redirect to="/dashboard" />} />
          )}
          <Route exact path={`${path}/alert`} component={AlertEmail}></Route>
          <Route exact path={`${path}/alert/:id/:group`} component={AlertEmail} />
          <Route exact path={`${path}/kioskLog`} component={KioskLog}></Route>
          <Route exact path={`${path}/kioskLog/:id/:group`} component={KioskLog} />
          <Route exact path={`${path}/messagePersonalization`} component={AlertCustom}></Route>
          <Route exact path={`${path}/downloadSales`} component={DownloadSales}></Route>
          <Route exact path={`${path}/messagePersonalization/:id/:group`} component={AlertCustom} />
          <SuperAdminRoute
            exact
            path={`${path}/transseting`}
            component={TransactionSetting}
          ></SuperAdminRoute>
          <SuperAdminRoute path={`${path}/email/manage-smtp`}>
            <SmtpConfiguration show={showSmtp} onHide={() => setShowSmtp(false)} />
          </SuperAdminRoute>
          <SuperAdminRoute path={`${path}/machinesOnMap`}>
            <SelectMachinesForMap />
          </SuperAdminRoute>
          <SuperAdminRoute path={`${path}/viewmachine`} component={ViewAllMachines} />
          <Route exact path={`${path}/magexsales`} component={MagexSales} />
          <Route exact path={`${path}/magexusers`} component={ViewMagexUser} />
          <Route exact path={`${path}/magexinvoice`} component={ViewMagexInvoice} />
          <Route exact path={`${path}/tickets`} component={Tickets} />

          <SuperAdminRoute exact path={`${path}/categories/:user`} component={ManageCategories} />
          <SuperAdminRoute exact path={`${path}/userActivityLog`} component={UserActivityLog} />
          <SuperAdminRoute exact path={`${path}/manageTechUsers`} component={ManageTechUsers} />
          <SuperAdminRoute
            exact
            path={`${path}/categories/:user/:category`}
            component={(props) => (
              <ManageProducts
                catename={props.match.params.category}
                user={props.match.params.user}
              />
            )}
          />
          <SuperAdminRoute
            exact
            path={`${path}/products/:user`}
            component={(props) => <ManageProducts user={props.match.params.user} />}
          />
        </Switch>
      </div>
    </div>
  );
}
